export * from 'utils/cookies';

import { h } from 'preact';
import Store from 'store/store';

import 'utils/cookies.sss';

const getOneTrustCookieSettingButtonText = (() => {
	let cache = null;
	return () => {
		if (cache) return cache;
		if (typeof window?.OneTrust?.GetDomainData !== 'function') {
			return null;
		}
		return cache = window.OneTrust.GetDomainData()?.CookieSettingButtonText || null;
	};
})();

export function showCookieConsent() {
	window.OneTrust?.ToggleInfoDisplay?.();
}

export function renderCookieConsentLink(linkName) {
	const { appData, client } = Store.get();
	const countryCode = client?.geo?.countryCode?.toLowerCase();
	const regionsToShowImg = appData?.options?.oneTrustCookieConsent?.regionsToShowImg?.split(',')?.map(r => r.trim().toLowerCase()) || [];
	const showImg = countryCode && regionsToShowImg.includes(countryCode);

	const studioRoot = appData?.urls?.roots?.studio || '';
	const name = getOneTrustCookieSettingButtonText() || linkName;

	return (
		<button class="cookie-consent" onClick={showCookieConsent}>
			{showImg && <img class="do-not-sell" src={`${studioRoot}/images/ccpa-icon/privacyoptions.svg`} role="presentation" />}
			{name}
		</button>
	);
}